const vehicleOwnershipBasisDocument = {
    id: 0,
    name: "",
    number: "",
    date: "",
    externalId: "",
    additionalInfo: "",
    legalPersonId: null,
    counterpartyId: "",
};

export { vehicleOwnershipBasisDocument };
